import React from "react";
import { isMobile } from "../../../../../utils/common";
import ChipSelect from "../../../../common/ChipSelect";
import { getOptionForValue } from "../../../../common/ChipSelect/utils";
import DurationSelector from "../../Dashboard/Graphs/DurationSelector";
import {
  getDurationFromTimeRange,
  getTimeRangeFromDuration,
} from "../../Dashboard/Graphs/DurationSelector/utils";
import { BrowserTableConfig } from "../config";
import { SourceOptions } from "./constants";
import {
  BrowserOptionsContainer,
  OptionsRow,
  Option,
  TableHeader,
  TableHeaderCell,
  CellText,
  Title,
  TitleLine,
  TrendingSubs,
} from "./styles";
import SortIndicator from "./SortIndicator";
import { DurationOptions } from "../../Dashboard/Graphs/DurationSelector/constants";
import ReactGA from "react-ga";

function BrowserOptions({
  filters,
  setFilters,
  filterLock,
  setSource,
  source,
}) {
  let durationOptions = { ...DurationOptions };
  delete durationOptions["3M"];
  return (
    <BrowserOptionsContainer>
      {isMobile() && (
        <TitleLine>
          <Title>Trending Stocks </Title>
        </TitleLine>
      )}

      <TrendingSubs>
        <OptionsRow>
          <Option>
              <ChipSelect
                currentOption={getOptionForValue(source, SourceOptions)}
                options={SourceOptions}
                label={"Source"}
                disabled={filterLock}
                setOption={(newOption) => {
                  setSource(newOption.value);
                }}
              />
            </Option>
          <Option>
            <DurationSelector
              disabled={filterLock}
              durationOptions={durationOptions}
              duration={getDurationFromTimeRange(filters.timeRange)}
              setDuration={(newDuration) => {
                ReactGA.event({
                  category: "App - Browser",
                  action: "Selected Time Range",
                  label: getTimeRangeFromDuration(newDuration),
                });
                setFilters({
                  ...filters,
                  timeRange: getTimeRangeFromDuration(newDuration),
                });
              }}
            />
          </Option>
        </OptionsRow>
      </TrendingSubs>

      <TableHeader>
        {BrowserTableConfig.map((column) => {
          if (column.sortable) {
            return (
              <TableHeaderCell
                disabled={filterLock}
                width={column.width}
                sortable={true}
                onClick={() => {
                  if (filterLock) {
                    return;
                  }
                  if (filters.sortBy.field === column.field) {
                    ReactGA.event({
                      category: "App - Browser",
                      action: "Changed Sort Order",
                      label: filters.sortBy.order === "ASC" ? "DESC" : "ASC",
                    });
                    setFilters({
                      ...filters,
                      sortBy: {
                        ...filters.sortBy,
                        order: filters.sortBy.order === "ASC" ? "DESC" : "ASC",
                      },
                    });
                  } else {
                    ReactGA.event({
                      category: "App - Browser",
                      action: "Changed Sort Column ",
                      label: column.field,
                    });
                    setFilters({
                      ...filters,
                      sortBy: {
                        ...filters.sortBy,
                        field: column.field,
                      },
                    });
                  }
                }}
              >
                <CellText
                  order={filters.sortBy.order}
                  active={filters.sortBy.field === column.field}
                >
                  {column.text}
                </CellText>
                <SortIndicator
                  order={filters.sortBy.order}
                  active={filters.sortBy.field === column.field}
                />
              </TableHeaderCell>
            );
          } else {
            return (
              <TableHeaderCell width={column.width}>
                {column.text}
              </TableHeaderCell>
            );
          }
        })}
      </TableHeader>
    </BrowserOptionsContainer>
  );
}
export default BrowserOptions;
